import { VagasCatFuncPK } from './vagas-cat-func-pk';
export class VagasCatFunc {
  id: VagasCatFuncPK = null;
  vgSit: string = null;
  vago: number = null;
  cdTransf: number = null;
  cdRedist: number = null;
  cdExtincao: number = null;
  cdCriacao: number = null;
  novaAreaEspec: number = null;
  ativEspec: number = null;
  atoEnquad: number = null;

  constructor(d?) {
    if (d) {
      this.id = d.id ? new VagasCatFuncPK(d.id) : null;
      this.vgSit = d.vgSit ? d.vgSit : null;
      this.vago = d.vago ? d.vago : null;
      this.cdTransf = d.cdTransf ? d.cdTransf : null;
      this.cdRedist = d.cdRedist ? d.cdRedist : null;
      this.cdExtincao = d.cdExtincao ? d.cdExtincao : null;
      this.cdCriacao = d.cdCriacao ? d.cdCriacao : null;
      this.novaAreaEspec = d.novaAreaEspec ? d.novaAreaEspec : null;
      this.ativEspec = d.ativEspec ? d.ativEspec : null;
      this.atoEnquad = d.atoEnquad ? d.atoEnquad : null;
    }
  }
}
